export const localStorageKeys = {
  AFFILIATE_OAUTH_PARAMS: 'aff_oauth_params',
  SELECTED_PLAN_SKU: 'selected_plan_sku',
} as const;
